import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';
import { apiAction as getBusinessKeys } from './getBusinessKeys';
import { apiAction as getKeys } from './getKeys';

const action = createActions({
  API_KEY: {
    DELETE_KEY: undefined,
    API: {
      DELETE_KEY: apiResourceActionCreator('key')
    }
  }
})

export const apiAction = (authToken, keyId) => commonApiActions.authenticated.delete(`${API_ENDPOINT}/delete-key/${keyId}`, authToken, action.apiKey.api.deleteKey)

export function* deleteKey({ payload }) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, payload.id));

  const deleteKeyResult = yield apiActionResult(action.apiKey.api.deleteKey);
  if (deleteKeyResult.success) {
    const keyType = payload.keyType;
    if (keyType === 'Business') {
      yield put(getBusinessKeys(authToken));
    } else {
      yield put(getKeys(authToken));
    }
  }
}

const configuration = {
  name: 'deleteKey',
  action: action,
  sagas: deleteKey,
  reducers: {
    request: (state, action) => ({
      ...state
    }),
    success: (state, action) => ({
      ...state
    }),
    failed: (state, action) => ({
      ...state
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/api-key/configurations/deleteKey.js